import { useCreateMap as useCreateMapRequest } from '../../../service/requests';
import {
  isFailure,
  failure,
  isSuccess,
  success,
  loading,
  type Response,
} from '../../../service/response';

export const useCreateMap = (name: string): any => {
  const { createMap: createLocationRequest } = useCreateMapRequest();
  const createMap = async (): Promise<Response<any, any>> => {
    const resp = await createLocationRequest(name);

    if (isFailure(resp)) {
      return failure(resp.error as Error);
    }

    if (isSuccess(resp)) {
      return success(null);
    }

    return loading();
  };

  return {
    createMap,
  };
};
